<template>
    <CheckboxGroup
        :name="`${step.name}[${data.element_details.name}]`"
        class="big-checkboxes--group"
        :unstyled="true"
        v-model="field.value"
    >   

        <div :class="'big-checkboxes ' + isSelected(field.value, option.value)" v-for="(option, index) in data.valueOptions">

            <Checkbox
                :inputId="`${step.name}[${data.element_details.name}]` + '-' + option.value"
                :value="option.value"
            />

            <label :for="`${step.name}[${data.element_details.name}]` + '-' + option.value">
                <div class="big-checkboxes--image" v-if="option.valueImage?.['icon-base64']">
                    <img :src="option.valueImage['icon-base64']" :alt="option.valueImage['label']">
                </div>
                <div class="big-checkboxes--label" v-hide="data.checkboxHideTitle">
                    <span v-html="option.label"></span>
                </div>
            </label>

        </div>

    </CheckboxGroup>
</template>

<script setup>
defineProps({
    data:Object,
    field:Object,
    step:Object
})

function isSelected(field, option){
    if(Array.isArray(field) === false) return '';
    if(field.includes(option)) {
        return 'is-active'; 
    }
    return '';

}
</script>